import axios from '@/utils/api'

const state = {
}

const getters = {
}

const actions = {
  async getArcGis ({ commit }) {
    const data = await axios({
      method: 'GET',
      url: `arcgis/url/webMap`
    })
    return data
  },
  async getArcGisMonitoramentoClausulas ({ commit }) {
    const data = await axios({
      method: 'GET',
      url: `arcgis/url/webMapMonitoramentoClausulas`
    })
    return data
  },
  async getUrlInventarioPatrimonialArcGis ({ commit }) {
    const data = await axios({
      method: 'GET',
      url: `arcgis/url/inventariopatrimonial`
    })
    return data
  },
  async getUrlAcervoFundiario ({ commit }) {
    const data = await axios({
      method: 'GET',
      url: `arcgis/url/acervoFundiario`
    })
    return data
  }
}

const mutations = {
}

export default {
  namespaced: true,
  state,
  mutations,
  actions,
  getters
}



// WEBPACK FOOTER //
// ./src/store/modules/analise/arcgis.js